export const oidcSettings = {
  authority: import.meta.env.VITE_APP_BD_OIDC_IP,
  client_id: import.meta.env.VITE_APP_OIDC_RP_CLIENT_ID_FRONT,
  redirect_uri: `${window.location.origin}/oidc-callback`,
  post_logout_redirect_uri: `${window.location.origin}`,
  responseType: "code",
  scope: "openid profile email",
  //silentRedirectUri: `${window.location.origin}/silent-renew-oidc.html`,
  automaticSilentRenew: true,
  validateSubOnSilentRenew: true,
  monitorSession: false,
  revokeAccessTokenOnSignout: true,
  loadUserInfo: true,
  accessTokenExpiringNotificationTime: 3 * 60,
};
